<template>
  <div class="UserBankAccounts">
    <b-list-group
        class="px-2"
      >
        <b-list-group-item
          class="flex-column align-items-start my-2"
          style="border-radius: 15px; border-color: black !important; cursor: pointer; border-top-width: 1px;"
          v-for="bank in UserBanksTmp"
          v-bind:key="bank.id"
        >
          <b-row align-v="center" align-h="start">
            <b-col md="2">
              <h5 class="mb-1 text-font-black">
                Nombre
              </h5>
              <p class="mb-1 text-light-black">
                <strong>{{ bank.name }}</strong>
              </p>
            </b-col>
            <b-col md="2">
              <h5 class="mb-1 text-font-black">
                Tipo
              </h5>
              <p class="mb-1 text-light-black">
                <strong>{{ bank.type.name }}</strong>
              </p>
            </b-col>
            <b-col md="3">
              <h5 class="mb-1 text-font-black">
                Correo electrónico
              </h5>
              <p class="mb-1 text-light-black">
                <strong>{{ bank.email }}</strong>
              </p>
            </b-col>
            <b-col md="2">
              <h5 class="mb-1 text-font-black">
                ACH
              </h5>
              <p class="mb-1 text-light-black">
                <strong>{{ bank.ach }}</strong>
              </p>
            </b-col>
            <b-col md="3">
              <h5 class="mb-1 text-font-black">
                Número de cuenta
              </h5>
              <p class="mb-1 text-light-black">
                <strong>{{ bank.number }}</strong>
              </p>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "UserBankAccounts",
  data() {
    return {
      UserBanksTmp: [],
      UserBanks: [],
      
      
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getUserBanks();
  },
  methods: {
    ...mapActions(["GetBanksByUser"]),
    getUserBanks() {
      let form = {
        id: this.$route.params.user_id,
      };
      this.GetBanksByUser(form).then((response) => {
        if (response.code == 200) {
          this.UserBanksTmp = response.data;
          this.totalRows = response.data.length;
        }
      });
    },
}
}
</script>
<style scoped></style>


